'use strict';

import _ from 'lodash';
import axios from 'axios';
import axiosCancel from 'axios-cancel';
import store from './store';
import router from './router';

import firebase from 'firebase';

const axios_instance = axios.create({
  baseURL: window._API,
});

/**
 * Methods:
 * axiosCancel(instance: axios[, options])
 * - options: debug (enables logging)
 * axios.cancel(requestId: string[, reason: string])
 * axios.cancelAll([reason: string])
 */
axiosCancel(axios_instance, {
  debug: false, // default
});

async function refreshSession() {
  return new Promise((resolve, reject) => {
    if (store.state.auth.authenticated == true && firebase.auth().currentUser != null) {
      let expires_at = store.state.auth.expires_at;
      let now = new Date();
      let diff = (expires_at - now) / 1000 / 60;
      if (diff < 5) {
        firebase
          .auth()
          .currentUser.getIdToken(true)
          .then((token) => {
            let updated_user = firebase.auth().currentUser;
            store.dispatch('auth/refresh', updated_user.toJSON());
            return resolve(true);
          })
          .catch(() => {
            // we can ignore errors.
            return resolve(true);
          });
      }
    } else {
      return resolve(true);
    }
  });
}

const handleRequest = function(config) {
  // Check token expiration
  refreshSession();

  // Used for single request cancellation
  config.requestId = config.url;

  let locale = _.get(store.state, 'locale.locale', 'en');
  config.headers['Accept-Language'] = locale;

  let token = _.get(store.state, 'auth.token');
  if (token) config.headers['Authorization'] = 'Bearer ' + token;

  if (config.method == 'get') {
    let params = config.params || {};
    // let currency = store.state.auth.currency || 'USD';
    // config.params = Object.assign(params, {currency: currency});
    config.params = Object.assign({}, params);
  }

  /**
   * HTML forms do not support PUT, PATCH or DELETE actions.
   * So, when defining PUT, PATCH or DELETE routes that are called from an HTML form,
   * you will need to add a hidden _method field to the form.
   * The value sent with the _method field will be used as the HTTP request method
   */
  if (config.method != 'get' && config.method != 'post') {
    if (config.data instanceof FormData) {
      config.data.append('_method', _.toUpper(config.method));
      config.method = 'post';
    }
  }

  return config;
};

const handleRequestError = function(error) {
  return Promise.reject(error);
};

const handleResponse = function(response) {
  return response;
};

const handleResponseError = function(error) {
  let status = _.get(error, 'response.status', null);
  let messages = _.get(error, 'response.data.errors', null);
  let auth = store.state.auth.authenticated;
  console.log('st', status, auth);
  if (status == 401 && auth == true) {
    axios_instance.cancelAll();
    store.dispatch('errors/put', {
      key: 'error',
      value: 'Your session is expired. Please sign in again.',
    });
    return store.dispatch('auth/logout');
  }

  if (status == 403) {
    axios_instance.cancelAll();
    store.dispatch('errors/put', {
      key: 'error',
      value: 'You have no access to this page.',
    });
    return router.replace('/');
  }

  if (status == 422) {
    store.dispatch('errors/put', {
      key: 'error',
      value: 'Your input is invalid.',
    });
  }

  if (status == 500) {
    store.dispatch('errors/put', {
      key: 'error',
      value: 'We have a problem on our server. Please try again later.',
    });
  }

  if (messages != null) {
    store.dispatch('errors/fromResponse', error.response.data);
  }

  return Promise.reject(error);
};

// Add a request interceptor.
// Inject auth token to request headers.
axios_instance.interceptors.request.use(
  (config) => handleRequest(config),
  (error) => handleRequestError(error)
);

// Add a response interceptor.
// Handle response.
axios_instance.interceptors.response.use(
  (response) => handleResponse(response),
  (error) => handleResponseError(error)
);

export default axios_instance;
